
const getToken = () => {
    // Check for OAuth token first, then fall back to regular JWT
    return localStorage.getItem('oauth_token') || localStorage.getItem('jwt'); 
};

const getAuthHeader = (token) => {
    if (!token) return {};
    
    // If token is a JWT (our internal format), use Bearer prefix
    // OAuth tokens are already prefixed with Bearer
    if (localStorage.getItem('jwt') === token) {
        return { 'Authorization': `Bearer ${token}` };
    } else {
        return { 'Authorization': `Bearer ${token}` };
    }
};

export const request = async (url, options = {}) => {
    let token = getToken();
    if (options.token) {
        token = options.token;
    }
    // Default headers
    const headers = {
        ...getAuthHeader(token)
    };

    if (options.json) {
        headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(options.json);
        delete options.json;
    }

    const response = await fetch(url, {
        ...options,
        headers
    });

    if (!response.ok) {
        const data = await response.json();
        return Promise.reject({...data, status: response.status});
    }

    return response.json();
};